var map = {
	"./aquathlon-2.svg": "f97a",
	"./aquathlon.svg": "fe55",
	"./arrow-left.svg": "4d59",
	"./arrow-right.svg": "d01a",
	"./athletics.svg": "9796",
	"./badge.svg": "b9c5",
	"./basketball-jersey.svg": "e992",
	"./basketball.svg": "17b8",
	"./beach-volleyball.svg": "eaee",
	"./biathlon.svg": "33be",
	"./boxing.svg": "72da",
	"./business.svg": "4ba4",
	"./calendar.svg": "18db",
	"./camera.svg": "d4c5",
	"./check-bold.svg": "eb07",
	"./check-circle-s.svg": "3e73",
	"./check-circle.svg": "68ce",
	"./chess.svg": "2c5a",
	"./climbing.svg": "14e1",
	"./close-circle-s.svg": "03f7",
	"./close-circle.svg": "0478",
	"./close.svg": "1e9a",
	"./compass.svg": "604b",
	"./copy.svg": "5e54",
	"./credit-card.svg": "ef58",
	"./cross-country-skiing.svg": "618f",
	"./curling.svg": "4cce",
	"./cycling.svg": "a47d",
	"./delete-stroke.svg": "613e",
	"./delete.svg": "d978",
	"./deposit.svg": "7b6f",
	"./dog-paw.svg": "eb1d",
	"./double-right.svg": "a114",
	"./down.svg": "3ef2",
	"./download.svg": "1c8a",
	"./duathlon.svg": "06dd",
	"./edit.svg": "7577",
	"./environment.svg": "f39c",
	"./equestrian-tourism.svg": "252f",
	"./excel-import.svg": "c8b7",
	"./exclamation-circle-s.svg": "a879",
	"./exclamation-circle.svg": "7d96",
	"./export.svg": "f8a4",
	"./external-link.svg": "7d8e",
	"./eye-invisible.svg": "9600",
	"./eye.svg": "6107",
	"./facebook.svg": "674d",
	"./family.svg": "38f3",
	"./file-done.svg": "dc42",
	"./five-of-five.svg": "078a",
	"./gift.svg": "a2cc",
	"./global.svg": "e58d",
	"./goalball.svg": "03a4",
	"./gymnastics.svg": "4555",
	"./handball.svg": "31f5",
	"./history.svg": "92fd",
	"./hockey.svg": "5f0f",
	"./hotel.svg": "dc58",
	"./hourglass.svg": "460e",
	"./id-card-bro.svg": "3f5a",
	"./info-circle.svg": "221b",
	"./instagram.svg": "4590",
	"./judo.svg": "536f",
	"./left.svg": "f191",
	"./line-chart.svg": "9171",
	"./loading.svg": "fefd",
	"./lock.svg": "fd72",
	"./logout.svg": "9b62",
	"./mail.svg": "9dc6",
	"./membership-card.svg": "d95b",
	"./menu.svg": "6f8a",
	"./minus.svg": "857a",
	"./mma.svg": "c615",
	"./mountain.svg": "1796",
	"./navigation.svg": "4a22",
	"./nordski.svg": "900a",
	"./odnoklassniki.svg": "703d",
	"./padlock.svg": "a8d5",
	"./password.svg": "3318",
	"./phone.svg": "f629",
	"./plus.svg": "733c",
	"./print.svg": "bde8",
	"./pulse.svg": "57dd",
	"./receipt.svg": "27b2",
	"./redo.svg": "8fbb",
	"./rhythmic-gymnastics.svg": "ec68",
	"./right.svg": "b9c1",
	"./rock-and-roll.svg": "83e1",
	"./rowing.svg": "5cb9",
	"./running.svg": "5cc5",
	"./safety-float.svg": "fc9e",
	"./search.svg": "eb4a",
	"./shopping-bag.svg": "798c",
	"./skiing.svg": "5786",
	"./snowboarding.svg": "245f",
	"./soccer-ball.svg": "6a66",
	"./soccer.svg": "90a2",
	"./solution.svg": "9438",
	"./speedscating.svg": "7313",
	"./sports-gymnastics.svg": "5d30",
	"./staircase.svg": "0f2a",
	"./star.svg": "f415",
	"./sup.svg": "9c3d",
	"./swimming.svg": "35d4",
	"./sync.svg": "dc80",
	"./table-tennis.svg": "b81b",
	"./table.svg": "fab9",
	"./team-add.svg": "a98a",
	"./team.svg": "1261",
	"./telegram.svg": "bb67",
	"./tennis.svg": "db8c",
	"./tiktok.svg": "1e11",
	"./time-limit.svg": "d696",
	"./timer.svg": "57c8",
	"./track-and-field.svg": "145b",
	"./triathlon.svg": "fd05",
	"./trophy.svg": "f735",
	"./undo.svg": "d9ed",
	"./up.svg": "1d9e",
	"./user-edit.svg": "0700",
	"./user-groups.svg": "3165",
	"./user.svg": "86d8",
	"./video.svg": "e0b2",
	"./vkontakte.svg": "9c63",
	"./volleyball.svg": "cbdf",
	"./walking.svg": "f529",
	"./warning-s.svg": "15f2",
	"./warning.svg": "f819",
	"./weightlift.svg": "cbfd",
	"./windsurfing.svg": "a290",
	"./withdrawal.svg": "c15f",
	"./wrestling.svg": "891e",
	"./youtube.svg": "a945"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b737";